import { useEffect } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import FreshSection from "./components/FreshSection";
import TopicsSection from "./components/TopicsSection";
import FocusSection from "./components/FocusSection";
import FaqAboutSection from "./components/FaqAboutSection";
import SubscribeSection from "./components/SubscribeSection";
import Footer from "./components/Footer";
import { faqs } from "@/mocks/home";

export default function Home() {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(script);
    return () => {
      if (script.parentNode) script.parentNode.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <FreshSection />
        <TopicsSection />
        <FocusSection />
        <FaqAboutSection />
        <SubscribeSection />
      </main>
      <Footer />
      <a
        href="#top"
        aria-label="回到顶部"
        className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50 shadow-sm transition hover:bg-primary-600"
      >
        <i className="ri-arrow-up-line text-lg"></i>
      </a>
    </div>
  );
}